import React from 'react';

import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';

import { formatSyncedMoney } from '../../Assets/utils';
import RelatedListCard from '../RelatedListCard';
import { accountPath } from '../accountRelatedModel';
import { useAccountOfferId } from '../useAccountOfferId';
import { useAccountRelatedPreview } from '../useAccountRelatedRows';

import { toAccountExpense } from './toAccountExpense';

interface Props {
  accountId: string;
}

export default function AccountExpensesCard({ accountId }: Props) {
  const offerId = useAccountOfferId();
  const { count, error, isLoading, rows: expenses } = useAccountRelatedPreview(accountId, 'expenses', toAccountExpense);

  return (
    <RelatedListCard
      count={count}
      error={error}
      icon={<ReceiptLongIcon color="action" />}
      isLoading={isLoading}
      title="Expenses"
      viewAllTo={accountPath(accountId, offerId, '/expenses')}
    >
      <TableContainer>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ minWidth: 200 }}>Expense Name</TableCell>
              <TableCell>Type</TableCell>
              <TableCell align="right">Total Cost</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {expenses.map((expense) => (
              <TableRow key={expense.id} hover>
                <TableCell>{expense.name}</TableCell>
                <TableCell>{expense.type}</TableCell>
                <TableCell align="right">{formatSyncedMoney(expense.currency, expense.totalCost) ?? '—'}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </RelatedListCard>
  );
}
